/// <reference types="@types/fhir/r4" />

import * as React from 'react';
import styled from '@emotion/styled';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import LanguageIcon from '@mui/icons-material/Language';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import { PractitionerOrOrganization } from '../../../../../../interfaces/interfaces';

const StyledNameSpecialty = styled('span')`
  font-weight: 700;
`;

interface PractitionerItemProps {
  practitioner: PractitionerOrOrganization;
  selectedIndex: string;

  handleListItemClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: string): void;

  getItem(x: string): void;
}

const ListItemStyled = styled(ListItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledURL = styled.a`
  color: #4b286d;
  text-decoration: none;

  &:hover {
    color: #092c4c;
  }
`;

const StyledIconDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

const PractitionerItem = ({ practitioner, getItem, selectedIndex, handleListItemClick }: PractitionerItemProps) => {
  const {
    id,
    name,
    specialty,
    distanceFromOrigin,
    orgType,
    address: { addressShort },
    telecom: { url },
    resourceType,
  } = practitioner;
  return (
    <>
      <ListItemButton
        id={id}
        data-item-id={id}
        selected={selectedIndex === id}
        onClick={(event) => {
          getItem(id);
          handleListItemClick(event, id);
        }}
      >
        <ListItemStyled alignItems="flex-start">
          <ListItemText
            primary={name}
            secondary={
              <>
                {resourceType === 'Practitioner' &&
                  (specialty !== '-' ? <StyledNameSpecialty>{specialty}</StyledNameSpecialty> : <span>Specialty info is not available</span>)}
                {resourceType === 'Organization' && <StyledNameSpecialty>{orgType}</StyledNameSpecialty>}
                {addressShort && (
                  <Typography sx={{ display: 'block' }} component="span" variant="body2" color="text.primary">
                    {addressShort}
                  </Typography>
                )}
              </>
            }
          />

          <StyledIconDiv>
            {!!distanceFromOrigin && <div>{distanceFromOrigin} km</div>}
            {url && (
              <>
                <StyledURL href={url?.includes('http') ? url : `http://${url}`} rel="noopener" target="_blank">
                  <LanguageIcon />
                </StyledURL>
                <div>Website</div>
              </>
            )}
          </StyledIconDiv>
        </ListItemStyled>
      </ListItemButton>
      <Divider variant="middle" component="li" />
    </>
  );
};

export default PractitionerItem;
